import AccountList from "SuperAdmin/Pages/AccountList/AccountList";
import AccountDetail from "SuperAdmin/Pages/AccountDetail/AccountDetail";
import AccountCreate from "SuperAdmin/Pages/AccountCreate/AccountCreate";
import RoleList from "SuperAdmin/Pages/RoleList/RoleList";
import RoleDetail from "SuperAdmin/Pages/RoleDetail/RoleDetail";
import RoleCreate from "SuperAdmin/Pages/RoleCreate/RoleCreate";
import UnitList from "SuperAdmin/Pages/UnitList/UnitList";
import FacultyProfileList from "SuperAdmin/Pages/FacultyProfileList/FacultyProfileList";
export const _routes = [
  {
    path: "/accounts",
    exact: true,
    component: AccountList,
    name: "Account list",
    permissions: [],
    level: 1,
  },
  {
    path: "/accounts/:id",
    exact: true,
    component: AccountDetail,
    name: "Account detail",
    permissions: [],
    level: 2,
  },
  {
    path: "/create-account",
    exact: true,
    component: AccountCreate,
    name: "Create account",
    permissions: [],
    level: 1,
  },
  {
    path: "/roles",
    exact: true,
    component: RoleList,
    name: "Role list",
    permissions: [],
    level: 1,
  },
  {
    path: "/roles/:id",
    exact: true,
    component: RoleDetail,
    name: "Role detail",
    permissions: [],
    level: 2,
  },
  {
    path: "/create-role",
    exact: true,
    component: RoleCreate,
    name: "Create role",
    permissions: [],
    level: 1,
  },
  {
    path: "/units",
    exact: true,
    component: UnitList,
    name: "Unit list",
    permissions: [],
    level: 1,
  },
  {
    path: "/profiles",
    exact: true,
    component: FacultyProfileList,
    name: "Faculty profile list",
    permissions: [],
    level: 1,
  },
];
